import { render, staticRenderFns } from "./document-viewer-entry.vue?vue&type=template&id=4c4c7f7e"
import script from "./document-viewer-entry.vue?vue&type=script&lang=js"
export * from "./document-viewer-entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports